import reasons from "@/http/requests/reasons"

export default {
  fetch({ commit }, params) {
    return new Promise((resolve, reject) => {
      reasons.fetch(params).then(response => {
        commit('SET_REASONS', response.data.data.reasons)
        resolve(response)
      }).catch((error) => { reject(error) });
    });
  }
}
